(function() {
    var $media_wrapper = $('#client-medias'),
        $media_items = $media_wrapper.find('.media-item'),
        $media_toggle_status = false,
        $media_filter_input = $media_wrapper.find('.media-name-filter-input'),
        $media_filter_reset = $media_wrapper.find('.media-name-filter-reset');

    //  Toggle All Button
    $('.btn-select-all').on('click', function(evt) {
        var $elt = $(evt.currentTarget),
            media_action;

        $elt.toggleClass('active');
        $media_toggle_status = !$media_toggle_status;

        if ($media_toggle_status) {
            media_action = "toggle";
        } else {
            media_action = "untoggle";
        }

        $media_items.each(function(index, element) {
            var $media = $(element);

            if ($media.css('display') === "block") {
                $media.trigger(media_action);
            } else {
                $media.trigger('untoggle');
            }
        });
    });

    //  Media Items Toggle
    $media_items.each(function (idx, elt) {
        var $media_item = $(elt),
            $wrap = $media_item.find('.wrap'),
            $checked_input = $media_item.find('.checked-input'),
            checked = false;

        $media_item
            .on('toggle', function() {
                checked = true;
                $media_item.addClass('checked');
                $checked_input.attr('disabled', false);
            })

            .on('untoggle', function() {
                checked = false;
                $media_item.removeClass('checked');
                $checked_input.attr('disabled', 'disabled');
            });

        $wrap
            .on('click', function(evt) {
                if (!checked) {
                    $media_item.trigger('toggle');
                } else {
                    $media_item.trigger('untoggle');
                }

                evt.preventDefault();
            });
    });

    //  Filter
    $media_filter_input.on('input', function(event) {
        var filter_value = $(this).val();

        if (filter_value.length > 0) {
            $media_items.each(function(index, item) {
                var $item = $(item);

                if ($item.data('name').indexOf(filter_value) != -1) {
                    $item.show();
                } else {
                    $item.hide();
                }
            });
        }

        if (filter_value.length === 0) {
            $media_items.show();
        }
    });

    $media_filter_reset.on('click', function(event) {
        $media_filter_input
            .val('')
            .trigger('input');

        event.preventDefault();
    });

    //  Download button
    $('.btn-download-selected').on('click', function() {
        if ($media_items.find('.checked-input:not(:disabled)').length == 0) {
            return false;
        }
    });
})();
